module.exports = __webpack_public_path__ + "static/media/icon-log-out.ddc0038a.svg";